import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import { WhiteboardRouteComponentLoader } from './WhiteboardRouteComponentLoader.tsx';

export const WhiteboardRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => (
	<WhiteboardRouteComponentLoader spaceKey={spaceKey} contentId={contentId} />
);

WhiteboardRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey },
	query: { focusedCommentId, focusedMentionId },
}: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'whiteboardScreen',
			id: contentId,
			attributes: {
				contentId,
				focusedCommentId,
				focusedMentionId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentType: 'whiteboard',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
